import { useMutation } from '@tanstack/react-query'

import { setMoneytreeJwtOnLogin } from '@src/api'
import { useAxios } from '@src/hooks/use-axios'

export const useSetMoneytreeJwtOnLogin = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: () => setMoneytreeJwtOnLogin(axiosInstance),
  })
}
